import { useContext } from 'react'
import { SavedReportsContext } from '../Contexts/SavedReportsProvider'

export const useSavedReportsContext = () => {
  const context = useContext(SavedReportsContext)
  if (!context) {
    throw new Error('useSavedReportsContext must be used inside SavedReportsProvider')
  }
  return context
}
